<template>
  <div>
    <v-container :class="{'auth-wrapper-xl': isXlScreen, 'auth-title-justify-center': isMobileScreen}">
      <v-app-bar class="logo-wrapper" app color="transparent" style="left: unset; right: unset" flat height="120">
        <a href="https://mpay.az">
          <img alt="logo" style="height: 40px" src="@/assets/logo-dark.svg">
        </a>
        <div v-if="!isMobileScreen && isReferrerUrl" class="referrer">
          <span class="referrer__text">{{ $t('label.transition.source') }}</span>
          <a class="referrer__logo" href="https://www.emanat.az/az" target="_blank">
            <img alt="emanat" src="@/assets/e-manat.svg">
          </a>
        </div>
      </v-app-bar>

      <v-main class="d-flex align-center">
        <router-view :key="$route.fullPath"/>
      </v-main>
    </v-container>
    <!-- <AppAdsModal></AppAdsModal> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// import AppAdsModal from '@/components/AppAdsModal';

export default {
  components: {
    // AppAdsModal,
  },
  data: () => ({
    links: ['Dashboard', 'Messages', 'Profile', 'Updates'],
    isReferrerUrl: !!sessionStorage.getItem('referrerUrl'),
  }),
  computed: {
    isMobileScreen() {
      return this.$vuetify.breakpoint.mobile;
    },
    isXlScreen() {
      return this.$vuetify.breakpoint.xlOnly;
    },
  },
  mounted() {
    if (this.$route.path !== '/auth/register' && this.$vuetify.breakpoint.width > 800) {
      this.connect(`${process.env.VUE_APP_BACKEND_WS_HOST}qrcode`);
    }
    this.$i18n.locale = localStorage.getItem('lang') ? localStorage.getItem('lang').toLowerCase() : 'az';

    if (document.referrer && document.referrer !== '') {
      if (document.referrer === 'https://www.emanat.az/' || document.referrer === 'https://l.instagram.com/') {
        this.isReferrerUrl = true;
        sessionStorage.setItem('referrerUrl', 'https://www.emanat.az/');
      }
    }
  },
  destroyed() {
    this.disconnect();
    this.$store.commit('websocket/setIsClosed', false);
  },
  methods: {
    ...mapActions('websocket', ['connect', 'disconnect']),
  },
};
</script>
<style lang="scss">
@import '@/styles/auth.scss';
@import "./style.scss";
.logo-wrapper{
  width: 100%;
  max-width: 1164px;
    .v-toolbar__content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
  }
}
@media (max-width: 1263px) {
  .logo-wrapper{
      .v-toolbar__content{
      justify-content: center;
    }
  }
}

</style>
